// BIN sağlayıcıları banka adını farklı yazıyor ("AKBANK", "Akbank T.A.Ş.",
// "T. GARANTİ BANKASI A.Ş."); ad sadeleştirilip anahtar kelimeyle eşlenir.
// Sıra önemli: "ziraat katilim" "ziraat"tan, "turkiye finans" "finans"tan önce gelmeli.
const BANK_LOGOS = [
    [/ziraat katilim/, "ziraatkatilim.png"],
    [/ziraat/, "ziraat.png"],
    [/vakif katilim/, "vakifkatilim.png"],
    [/vakif/, "vakifbank.png"],
    [/turkiye finans/, "turkiyefinans.png"],
    [/finans|qnb/, "finansbank.png"],
    [/turkiye is|\bis bank|isbank/, "isbankasi.png"],
    [/garanti/, "garanti.png"],
    [/akbank/, "akbank.png"],
    [/aktif/, "aktifbank.png"],
    [/yapi/, "yapikredi.png"],
    [/halk/, "halkbank.png"],
    [/deniz/, "denizbank.png"],
    [/seker/, "sekerbank.png"],
    [/turk ekonomi|\bteb\b/, "teb.png"],
    [/\bing\b/, "ing.png"],
    [/hsbc/, "hsbc.png"],
    [/icbc/, "icbc.png"],
    [/kuveyt/, "kuveytturk.png"],
    [/albaraka/, "albaraka.png"],
    [/alternatif/, "alternatifbank.png"],
    [/anadolubank/, "anadolubank.png"],
    [/burgan/, "burgan.png"],
    [/eurobank/, "eurobank.png"],
    [/citi/, "citibank.png"],
    [/fiba/, "fibabanka.png"],
    [/odea/, "odeabank.png"],
    [/turkland|t-bank|\btbank\b/, "tbank.png"],
    [/turkish bank/, "turkishbank.png"],
];

const normalize = (name) =>
    name
        .toLocaleLowerCase("tr")
        .replace(/ı/g, "i").replace(/ş/g, "s").replace(/ğ/g, "g")
        .replace(/ü/g, "u").replace(/ö/g, "o").replace(/ç/g, "c")
        .replace(/\s+/g, " ")
        .trim();

// Eşleşme yoksa boş döner; kart görseli logo yerine banka adını yazar.
export const resolveBankLogo = (bankName) => {
    if (!bankName) return "";
    const n = normalize(bankName);
    const hit = BANK_LOGOS.find(([re]) => re.test(n));
    return hit ? `/images/banks/${hit[1]}` : "";
};

const SCHEMA_LOGOS = { VISA: "visa.png", MASTERCARD: "mastercard.png", TROY: "troy.png", AMEX: "amex.png" };

export const resolveCardSchemaLogo = (schema) => {
    const file = SCHEMA_LOGOS[(schema || "").toUpperCase()];
    return file ? `/images/cards/${file}` : "";
};
